<mat-dialog-content>
  <lemon-dialog-header> Veroilmoituksen osakkaiden tiedot </lemon-dialog-header>

  <div app-kirjanpito-veroilmoitus-osakkaat #osakkaatComp [veroilmoitusObservable]="veroilmoitusObservable" [showSnackbar]="true"></div>
</mat-dialog-content>

<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-secondary-button mat-dialog-close actionId="Peruuta (veroilmoitus osakkaat dialog)">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Tallenna osakkaat">Tallenna</app-primary-button>
</mat-dialog-actions>
